<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle">Table of Contents</h1><p class="left"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="left"><a href="#/toc">Table of Contents</a></p>
<p class="left"><a href="#/front01">Copyright</a></p>
<p class="left"><a href="#/front02">Acknowledgements</a></p>
<p class="left"><a href="#/front03">Preface
</a></p>
<p class="left"><a href="#/c01">Integrity</a></p>
<p class="left"><a href="#/c02">Has Israel Altered its Visions?</a></p>
<p class="left"><span href="#/c03" title="Link target outside of Sample">The Real Cause of My Grandmother’s Death</span></p>
<p class="left"><span href="#/c04" title="Link target outside of Sample">From Jerusalem to Cairo</span></p>
<p class="left"><span href="#/c05" title="Link target outside of Sample">Between Europe and the Negev Desert</span></p>
<p class="left"><span href="#/c06" title="Link target outside of Sample">Peace and Love and Compromise</span></p>
<p class="left"><span href="#/c07" title="Link target outside of Sample">Whose Holy Land?</span></p>
<p class="left"><span href="#/c08" title="Link target outside of Sample">Telling Stories under Siege</span></p>
<p class="left"><span href="#/c09" title="Link target outside of Sample">The Israeli-Palestinian Conflict: Tragedy, Comedy and Cognitive Block</span></p>
<p class="left"><span href="#/c10" title="Link target outside of Sample">At the Bridge</span></p>
<p class="left"><span href="#/c11" title="Link target outside of Sample">Hizbollah in a Skullcap</span></p>
<p class="left"><span href="#/c12" title="Link target outside of Sample">Clearing the Minefields of the Heart</span></p>
<p class="left"><span href="#/back01" title="Link target outside of Sample">Read More from Amos Oz</span></p>
<p class="left"><span href="#/back02" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?68c34c43